import MoveTo from 'moveto';


$(document).ready(function($) {


  const moveTo = new MoveTo({tolerance: 53,duration: 800,easing: 'easeOutQuart'});

  const triggers = document.querySelectorAll("[href^='#']");

  for (let i = 0; i < triggers.length; i++) {
    moveTo.registerTrigger(triggers[i]);
  }

  const urlHash = window.location.hash;

  if(urlHash){
    const target = document.getElementById(urlHash);
    moveTo.move(target);
  }

});